<template>
    <ModalComponent
        :name='"editar-" + codigo.id'
        title='Editar código de invitación'
        v-on:close="() => close(false)"
    >
        <FormEditarCodigos :usos="codigo.usos" @terminado="terminar"/>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormEditarCodigos from '../components/FormEditarCodigos.vue';

    export default {
        props: ['codigo'],
        methods: {
            close() {
                this.$emit('close', 'editar-' + this.codigo.id);
            },
            terminar(usos) {
                this.$emit('terminar', usos, this.codigo.id);
            }
        },
        components: {
            ModalComponent, FormEditarCodigos
        }
    }
</script>
